module.exports = __webpack_public_path__ + "img/cornerLeftTop.6424ccc2.svg";